// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"230":"f48fc75f","453":"7084eccf"}[chunkId] + ".chunk.js";
};